export const ShipmentTrackingRecordsActionTypes = {
    API_RESPONSE_SUCCESS: '@@shipment-tracking-records/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@shipment-tracking-records/API_RESPONSE_ERROR',
    PROCESS_TRACKING_RECORDS: '@@shipment-tracking-records/PROCESS_TRACKING_RECORDS',
    RESET_STATE: '@@shipment-tracking-records/RESET_STATE',
};
